import {Service, Module} from 'app/decorators.js';
import R from 'app/resource';
import BaseStore from './base';


@Module({
    name: 'app.store.product',
    modules: [
        R,
    ],
})
@Service('ProductStore')
export default class Store extends BaseStore {
    constructor ($q, R) {
        "ngInject";
        super($q, R);
        this.endpoint = this.R.all('products');
    }
}



// WEBPACK FOOTER //
// ./src/app/stores/product.js